import { render, staticRenderFns } from "./preferences-values.vue?vue&type=template&id=ab031362&scoped=true"
import script from "./preferences-values.vue?vue&type=script&lang=js"
export * from "./preferences-values.vue?vue&type=script&lang=js"
import style0 from "./preferences-values.vue?vue&type=style&index=0&id=ab031362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab031362",
  null
  
)

export default component.exports